import { Form, Popup } from 'devextreme-react';
import {
  ButtonItem,
  ButtonOptions,
  GroupItem,
  Label,
  RequiredRule,
  SimpleItem,
} from 'devextreme-react/form';
import React, { useRef, useState } from 'react';
import '../../assets/bulk-modal.scss';
import { useTranslation } from '../../contexts/translation';
import { CapacityCategory } from '../../types/capacityCategory.types';
import { Step } from '../../types/step.types';
import './TasksBulkEditModal.scss';

type Props = {
  stepList: Step[];
  capacityCategories: CapacityCategory[];
  defaultCapacityCategoryId: number;
  isVisible: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
};

export default function StepGroupStepModal({
  stepList,
  capacityCategories,
  defaultCapacityCategoryId,
  isVisible,
  onClose,
  onSubmit,
}: Props) {
  const { translate } = useTranslation();
  const transFormName = 'StepGroup.List';
  const formRef = useRef<Form>(null);
  const [formData, setFormData] = useState<any>({});
  const [capacityCategoryId, setCapacityCategoryId] = useState<number | null>(
    defaultCapacityCategoryId,
  );

  return (
    <Popup
      visible={isVisible}
      dragEnabled={false}
      closeOnOutsideClick={false}
      onHiding={onClose}
      showTitle
      title={translate!('Assign step to group', transFormName)}
      width={'auto'}
      height={'auto'}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(formData);
        }}
      >
        <Form
          formData={formData}
          showColonAfterLabel={true}
          showValidationSummary={true}
          ref={formRef}
        >
          <GroupItem>
            <SimpleItem
              dataField="capacityCategoryId"
              editorType="dxSelectBox"
              editorOptions={{
                items: capacityCategories,
                valueExpr: 'id',
                displayExpr: 'name',
                width: 400,
                showClearButton: true,
                value: capacityCategoryId,
                onValueChanged: (e: any) => {
                  setFormData({ ...formData, stepId: undefined });
                  setCapacityCategoryId(e.value);
                },
              }}
            >
              <Label text={translate!('Capacity category', transFormName)} />
            </SimpleItem>
          </GroupItem>
          <GroupItem>
            <SimpleItem
              dataField="stepId"
              editorType="dxSelectBox"
              editorOptions={{
                items: capacityCategoryId
                  ? stepList.filter((x) => x.capacityId === capacityCategoryId)
                  : stepList,
                valueExpr: 'id',
                displayExpr: 'name',
                width: 400,
              }}
            >
              <Label text={translate!('Step', transFormName)} />
              <RequiredRule message={translate!('Step is required', transFormName)} />
            </SimpleItem>
          </GroupItem>
          <GroupItem colCount={4}>
            <GroupItem colSpan={2}></GroupItem>
            <ButtonItem>
              <ButtonOptions
                width={'100%'}
                type={'normal'}
                text={translate!('Save', '')}
                useSubmitBehavior
              />
            </ButtonItem>
            <ButtonItem>
              <ButtonOptions
                width={'100%'}
                type={'normal'}
                text={translate!('Close', '')}
                onClick={onClose}
              />
            </ButtonItem>
          </GroupItem>
        </Form>
      </form>
    </Popup>
  );
}
